import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getUserQueries } from "../../../../service/endpoints";

export const QueiryHandler = createAsyncThunk('QueiryHandler', async () => {
    try {
        const response = await getUserQueries()
        console.log(response.data,'dashboard')
        return response.data
       

        } catch (error) {
            if (error.response !== undefined) {
                console.log('fail', error)
                throw error.response
            }
            else {
                console.log(error)
                throw error.response
            }
        }
    })


const QueirySlice = createSlice({
    name: 'get_quiery',
    initialState: {
        isLoading: false,
        data: null,
        isError: false
    },
    extraReducers: (builder) => {
        builder.addCase(QueiryHandler.fulfilled, (state, action) => {
            state.isLoading = false;
            state.data = action.payload;
        });
        builder.addCase(QueiryHandler.pending, (state, action) => {
            state.isLoading = true
        });
        builder.addCase(QueiryHandler.rejected, (state, action) => {
            console.log(action.state)
            state.isError = true;
            console.log(action.payload);

        });
    }

})

export default QueirySlice.reducer;